module.exports = __webpack_public_path__ + "static/renaud-8a264a7b38e9078038d7dde7d787cfd7.jpg";